import { SpinnerService } from '@cpd-app/core-module/services';
import { withLatestFrom, filter, map, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { AppState } from '..';

import * as LoaderActions from './loader.actions';
import * as LoaderSelectors from './loader.selectors';

@Injectable()
export class LoaderEffects {
  constructor(
    private store: Store<AppState>,
    private actions: Actions,
    private spinnerService: SpinnerService
  ) {}

  showLoaderUntil$ = createEffect(() =>
    this.actions.pipe(
      withLatestFrom(
        this.store.select(LoaderSelectors.selectActionType),
        this.store.select(LoaderSelectors.selectShowLoader)
      ),
      filter(
        ([action, actionType, showLoader]) =>
          showLoader && action.type === actionType
      ),
      tap(() => this.spinnerService.hideSpinner()),
      map(() => LoaderActions.resetState())
    )
  );
}
